module.exports = __webpack_public_path__ + "img/5.ac55f79b.png";